import React from 'react';
import createReactClass from 'create-react-class';
import auth0 from '../helpers/auth0';
// import request from '../helpers/request';
// import appConfig from '../config/appConfig';

const RoleSelection = createReactClass({
  allRoles: ['Admin', 'Bauhofmitarbeiter', 'Buergermeister', 'Buchhaltung', 'Controlling', 'Lagerist', 'SyncService' ],

  getInitialState() {
    return {
      roleName: auth0.getOverrideRoleName() || 'Admin'
    };
  },

  handleChangeRole(overrideRoleName) {
    auth0.setOverrideRoleName(overrideRoleName);
  },

  render() {
    let { roleName } = this.state;

    let roleItems = this.allRoles.map(r => {
      let isActive = (r === roleName);
      return(
        <li key={r}>
          <a onClick={() => this.handleChangeRole(r)}>{isActive ? (<i className="fa fa-check"></i> ) : null} {r}</a>
        </li>
      );
    });

    return (
      <ul className="header-dropdown-list hidden-xs">
        <li className="">
          <a className="dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
            <span> {roleName}</span> <i className="fa fa-angle-down"></i>
          </a>
          <ul className="dropdown-menu pull-right">
            {roleItems}
          </ul>
        </li>
      </ul>
    );
  }
});

export default RoleSelection;



// WEBPACK FOOTER //
// ./src/components/RoleSelection.js